import React, { FC, useState, useEffect } from "react";
import { withProcedureWraper } from "../..";
import { Box } from "../../../../components/box";
import { Button, Col, Container, Row } from "react-bootstrap";
import FontFa from "../../../../components/fontFa/fontFa";
import { DocumentTypeService } from "../../../../services/lookup-data/document-type.service";
import { CreateNotification } from "../../../../components/notifier";
import { TreeTable, TreeState } from "cp-react-tree-table";
import EditDocumentTypeModal from "../modal/edit-document-type-modal";
import WarningDeleteModal from "../../../../modals/warning-delete-modal";
import { checkingAcessToken } from "../../../../helper/util";
import { useSelector } from "../../../../store/store";
import { checkLoggingStatus } from "../../../../constants/statusConstants";

export const SettingDocumentTypePage: FC = withProcedureWraper(() => {
  const user = useSelector((state) => state.user);
  const mainState = useSelector((state) => state.main);
  const [documentTypes, setDocumentTypes] = useState<any>();
  const [currentData, setCurrentData] = useState<any>();
  const [openEditDepartmentDetailModal, setOpenEditDepartmentDetailModal] = useState(false);
  const [showDeletedConfirm, setShowDeletedConfirm] = useState(false);
  const [deleteTitle, setDeleteTitle] = useState("");
  const [deleteMessage, setDeleteMessage] = useState("");

  const getData = () => {
    DocumentTypeService.getList().then(
      (res) => {
        let treeData: any = [];
        if (res.length > 0) {
          res.forEach((p: any) => {
            let item: any = p;
            treeData.push({
              data: item,
            });
          });
        }

        if (treeData.length > 0) {
          const temp = TreeState.create(treeData);
          setDocumentTypes(TreeState.expandAll(temp));
        } else {
          setDocumentTypes(TreeState.createEmpty());
        }
      },
      (error) => {
        CreateNotification({
          title: "Thông báo",
          body: `Không thể lấy danh sách loại tài liệu.`,
          icon: "/icons/error.png",
        });
        console.log(error);
      },
    );
  };

  const handleDeleteConfirmDialog = async (row: any) => {
    setCurrentData(row.data);
    setDeleteTitle(row.data.label ? "Xóa loại tài liệu" : "Xóa loại tài liệu");
    let message = `Bạn có muốn xóa loại tài liệu '${row.data.label}' không?`;
    if (!row.data.label) {
      message = row.metadata.hasChildren
        ? `Bạn có muốn loại tài liệu '${row.data.label}' và những đơn vị ban hành của nó không?`
        : `Bạn có muốn xóa loại tài liệu '${row.data.label}' không?`;
    }

    setDeleteMessage(message);
    setShowDeletedConfirm(true);
  };

  const handleDeleteData = async (data: any) => {
    await DocumentTypeService.delete(data.value);

    if (data.children?.length > 0) {
      data.children.forEach(async (item: any) => {
        await DocumentTypeService.delete(item.value);
      });
    }
    await getData();
  };

  const toggleDeleteConfirmDialog = () => {
    setShowDeletedConfirm(!showDeletedConfirm);
  };

  const onSaveComplete = async (row: any) => {
    await getData();
  };

  const handleShowDetailForm = async (row: any, parentRow: any) => {
    let data: any = null;
    if (!row) {
      data = {
        Title: parentRow?.data.Title,
      };
    } else {
      data = row.data;
    }
    setCurrentData(data);
    setOpenEditDepartmentDetailModal(!openEditDepartmentDetailModal);
  };

  const renderTitleEditableCell = (row: any) => {
    return (
      <div
        style={{ paddingLeft: row.metadata.depth * 15 + "px" }}
        className={row.metadata.hasChildren ? "with-children" : "without-children"}
      >
        {row.metadata.hasChildren ? <button className="toggle-button" onClick={row.toggleChildren}></button> : ""}
        <span>{row.data.label}</span>
      </div>
    );
  };

  const renderActionEditableCell = (row: any) => {
    return (
      <div className="document-action p-2 d-flex justify-content-end border-left">
        <Button
          title="Chỉnh sửa"
          onClick={(e) => {
            e.stopPropagation();
            handleShowDetailForm(row, null);
          }}
          className="text-info"
          variant="outline"
        >
          <FontFa name="faEdit" size="sm" />
        </Button>
        <Button
          title="Xóa"
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteConfirmDialog(row);
          }}
          className="text-danger"
          variant="outline"
        >
          <FontFa name="faTrash" size="sm" />
        </Button>
      </div>
    );
  };

  const toggleEditDepartmentDetailModal = () => {
    setOpenEditDepartmentDetailModal(!openEditDepartmentDetailModal);
  };

  useEffect(() => {
    if (checkingAcessToken(user, mainState) !== checkLoggingStatus.OK) {
      return;
    }

    if (documentTypes) return;

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainState.isExpiredToken, mainState.isUnauthorized]);

  return (
    documentTypes && (
      <>
        <div className="ProcedureTrainingPlanPage">
          <div className="pd15">
            <div className="d-flex p-3 justify-content-center">
              <h3>
                <br />
              </h3>
            </div>
            <Box
              title={"Quản lý loại tài liệu"}
              titleRight={
                <div className="px-4 py-2 d-flex align-items-center">
                  <Button
                    className="mr-2 button-info"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShowDetailForm(null, null);
                    }}
                    variant="info"
                  >
                    {"Thêm loại tài liệu"}
                  </Button>
                </div>
              }
            >
              <Container>
                <Row>
                  <Col xs={12} sm={12}></Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12}>
                    <TreeTable value={documentTypes} headerHeight={30}>
                      {/* <TreeTable.Column renderCell={renderIndexCell}
                                renderHeaderCell={() => <span></span>}/> */}
                      <TreeTable.Column
                        renderCell={renderTitleEditableCell}
                        basis="850px"
                        renderHeaderCell={() => <span>Tên</span>}
                      />
                      <TreeTable.Column
                        basis="70px"
                        renderCell={renderActionEditableCell}
                        renderHeaderCell={() => <span></span>}
                      />
                    </TreeTable>
                  </Col>
                </Row>
              </Container>
            </Box>
            <Col xs={12} sm={8}>
              <EditDocumentTypeModal
                onClose={toggleEditDepartmentDetailModal}
                isOpen={openEditDepartmentDetailModal}
                data={currentData}
                onSaveComplete={onSaveComplete}
              />
              <WarningDeleteModal
                data={currentData}
                title={deleteTitle}
                message={deleteMessage}
                isOpen={showDeletedConfirm}
                onDelete={handleDeleteData}
                onClose={toggleDeleteConfirmDialog}
              />
            </Col>
          </div>
        </div>
      </>
    )
  );
});
